import { useAuthInfo } from '@propelauth/react';
import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import {
  getUserAssignedClientId,
  getUserRoles,
  hasSomeRoles,
  UserRole,
} from '../../entities/user/domain/user.types';
import { userSelector } from '../../entities/user/store/user.selectors';
import { NavigationPaths } from '../../shared/domain/constants/routing.constants';
import { useAppSelector } from '../store/utils/redux.hooks';

interface IProps {
  children: ReactNode;
}

export default function RequireNonAuthRoute({ children }: IProps) {
  const { isLoggedIn } = useAuthInfo();
  const user = useAppSelector(userSelector);
  const roles = getUserRoles(user);
  const assignedClientId = getUserAssignedClientId(user);

  if (isLoggedIn && roles && hasSomeRoles([UserRole.REVI_EMPLOYEE], roles)) {
    return <Navigate to={NavigationPaths.CLIENTS} replace />;
  }

  if (isLoggedIn && assignedClientId) {
    return <Navigate to={NavigationPaths.TARGET_REQUIREMENTS(assignedClientId)} replace />;
  }

  return <>{children}</>;
}
